import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingInvalidCardIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="201"
        height="154"
        viewBox="0 0 201 154"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M141.573 1.29955C164.938 4.61203 194.253 17.1949 199.575 35.73C204.901 54.3134 186.247 78.8036 168.488 98.3975C150.736 118.037 133.896 132.783 113.265 142.717C92.6365 152.609 68.2619 157.761 51.8562 148.431C35.4959 139.166 27.1612 115.445 17.4539 94.5542C7.71543 73.6178 -3.41549 55.4658 1.85645 42.741C7.13974 30.0645 28.8259 22.8122 45.138 18.2508C61.4501 13.6894 72.34 11.7678 86.5421 7.87909C100.696 3.93931 118.16 -2.01293 141.573 1.29955Z"
          fill="#F9F9F9"
        />
        <rect
          x="49.1694"
          y="38.4998"
          width="114.454"
          height="78.6869"
          rx="12"
          fill="#006DFF"
        />
        <rect
          x="49.1665"
          y="54.949"
          width="114.454"
          height="12.876"
          fill="#E8F0FF"
        />
        <rect
          x="66.3345"
          y="79.7869"
          width="40.0588"
          height="5.00735"
          rx="2.50367"
          fill="#E8F0FF"
        />
        <path
          d="M156.75 131.167C169.867 131.167 180.5 120.533 180.5 107.417C180.5 94.2997 169.867 83.6665 156.75 83.6665C143.633 83.6665 133 94.2997 133 107.417C133 120.533 143.633 131.167 156.75 131.167Z"
          fill="#E90200"
        />
        <path
          d="M166.093 96.9998L146.333 117.833M147.406 96.9998L167.166 117.833"
          stroke="#F2F7FF"
          strokeWidth="5"
          strokeMiterlimit="10"
        />
      </svg>
    );
  }
);
export default BillingInvalidCardIcon;
